import { keyframes, styled } from "@mui/material";
import { ColorSAP, FONT_FAMILY } from "../../ontego-ui";

const Styled = {};

// Define the infinite rotation keyframes
const infiniteRotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

Styled.AppPreviewContainer = styled("div")(() => ({
  width: 226,
  zIndex: 1000,
  textAlign: "center",
  fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 16,
}));

Styled.AppPreviewWrapper = styled("div")(() => ({
  position: "relative",
}));

Styled.CarouselArrowContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "isDisabled",
})(({ isDisabled }) => ({
  cursor: isDisabled ? "" : "pointer",
  position: "absolute",
  top: "45%",
  width: 40,
  height: 40,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& svg": {
    color: ColorSAP.primary[70],
    opacity: 0.5,
    transition: "0.15s all ease-in-out",
  },
  "&:hover": {
    "& svg": {
      color: ColorSAP.primary[70],
      opacity: isDisabled ? 0.5 : 1,
      transition: "0.15s all ease-in-out",
    },
  },
}));

Styled.CarouselArrowLeft = styled(Styled.CarouselArrowContainer)(() => ({
  left: -42,
}));

Styled.CarouselArrowRight = styled(Styled.CarouselArrowContainer)(() => ({
  right: -42,
}));

Styled.AppPreviewImageContainer = styled("div")(() => ({
  position: "relative",
  userSelect: "none",
  width: 200,
  margin: "0 auto",
}));

Styled.AppPreviewTextContainer = styled("div")(() => ({
  width: "100%",
  textWrap: "nowrap",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  bottom: -36,
}));

Styled.CarouselContainer = styled("div")(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  position: "absolute",
  bottom: -66,
}));

Styled.SidebarContainer = styled("div")(() => ({
  position: "sticky",
  top: 190,
}));

Styled.SidebarDrawerContainer = styled("div")(() => ({
  marginTop: 40,
  borderRight: `2px solid ${ColorSAP.neutral[15]}`,
  paddingRight: 24,
  overflow: "auto",
  "&::-webkit-scrollbar": {
    webkitAppearance: "none",
    width: 7,
  },
  "&::-webkit-scrollbar-thumb": {
    borderRadius: 100,
    backgroundColor: ColorSAP.secondary[15],
    paddingRight: 9,
  },
}));

Styled.AddedToCollection = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: 290,
  height: 44,
}));

Styled.ClickToPreview = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

Styled.NoDataLayout = styled("div")(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  textAlign: "-webkit-center",
}));

Styled.DialogClose = styled("div")(() => ({
  width: 48,
  height: 48,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
}));

Styled.DialogCarouselArrowLeft = styled(Styled.CarouselArrowContainer)(() => ({
  left: -99,
  width: 72,
  height: 72,
}));

Styled.DialogCarouselArrowRight = styled(Styled.CarouselArrowContainer)(() => ({
  right: -99,
  width: 72,
  height: 72,
}));

Styled.DialogImage = styled("div")(() => ({
  borderRadius: 12,
  overflow: "hidden",
  maxHeight: "60vh",
}));

Styled.DialogCarouselContainer = styled("div")(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  position: "absolute",
  bottom: -56,
}));

Styled.ButtonPreviewContainer = styled("div")(() => ({
  position: "absolute",
  bottom: 80,
  left: 21,
  width: 159,
  transform: "scale(0.8)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

Styled.ImageLoadingOverlay = styled("div")(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 10,
  // background: "rgba(0, 0, 0, 0.5)",
  borderRadius: 8,
  width: "100%",
  height: "100%",
  maxWidth: 290,
  maxHeight: 290,
  "& svg": {
    animation: `${infiniteRotate} 1s linear infinite`,
  },
}));

Styled.DialogImageLoadingOverlay = styled("div")(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 10,
  // background: "rgba(0, 0, 0, 0.3)",
  borderRadius: 12,
  width: "100%",
  height: "100%",
  maxHeight: "60vh",
  "& svg": {
    animation: `${infiniteRotate} 1s linear infinite`,
  },
}));

Styled.ContentLayout = styled("div")(() => ({
  display: "flex",
  gap: 64,
  alignItems: "stretch",
  width: "100%",
  paddingTop: 86,
}));

Styled.SidebarColumn = styled("div")(() => ({
  width: 288,
  flexShrink: 0,
}));

Styled.MainColumn = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "stretch",
  flex: 1,
  minWidth: 0,
}));

Styled.MiddleContent = styled("div")(() => ({
  width: 443,
  position: "relative",
  display: "flex",
  flexDirection: "column",
}));

Styled.RightColumn = styled("div")(() => ({
  flexShrink: 0,
}));

Styled.RightSticky = styled("div")(() => ({
  position: "sticky",
  top: 190,
}));

export default Styled;
